import React from "react";
import PropTypes from "prop-types";
import { Row } from "antd";

const HomePageHeader = (props) => {
  const { children, ...rest } = props;
  return <Row {...rest}>{children}</Row>;
};

HomePageHeader.defaultProps = {
  children: null,
};

HomePageHeader.propTypes = {
  children: PropTypes.element,
};

export default HomePageHeader;
